export default __webpack_public_path__ + "static/media/web-1.6b0056d7.webp";